<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  start="{{startStage}}"
  end="{{endStage}}"
></app-ion-common-header>

<ion-content
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <app-ion-common-label
    [id]="idLabelCompanyInformation"
    class="document-type-label1"
    labelStyle="display-rg"
    labelDescription="Informações da empresa"
    label="Você pode encontrar o CNPJ da sua empresa na sua folha de pagamento."
  >
  </app-ion-common-label>

  <div class="conent-center conent-center--mrt-lg">
    <form [formGroup]="companyCnpjForm" (ngSubmit)="submitForm($event)">
      <app-ion-common-input
        [fieldValue]="numberCnpj"
        [placeholder]="placeholder"
        [error]="error"
        [verifyMsgError]="verifyMsgError"
        [id]="idComponentCnpj"
        [textError]="textErrorCnpj"
        maxLength="14"
        (textChange)="numberCnpj=$event; verifyCnpj(); errorMsg();"
        type="text"
        [idLabel]="idLabelCnpj"
        [label]="label"
        [disabled]="!this.edit"
        name="companyCnpj"
        formControlName="companyCnpj"
        [labelInputText]="true"
        ngDefaultControl
        isEnablePaste="true"
      >
      </app-ion-common-input>
    </form>
  </div>

  <form
    [ngClass]="{'hidden': !labelEnable}"
    [attr.aria-hidden]="!labelEnable"
    [formGroup]="companyNameForm"
    (ngSubmit)="submitForm($event)"
  >
    <div class="center-company-name">
      <app-ion-common-input
        [fieldValue]="nameCompany"
        [placeholder]="placeholderName"
        [error]="errorName"
        [verifyMsgError]="verifyMsgError"
        [id]="idComponentCompanyName"
        [textError]="textErrorName"
        maxLength="23"
        (textChange)="nameCompany=$event; errorMsgName();"
        type="text"
        [idLabel]="idLabelName"
        [label]="labelName"
        [labelInput]="labelInput"
        [disabled]="!this.edit"
        name="companyName"
        formControlName="companyName"
        [labelInputText]="true"
        ngDefaultControl
      >
      </app-ion-common-input>
    </div>
  </form>

  <app-ion-common-button
    [id]=" idButtonCompanyInformation"
    class="hidden"
    [ngClass]="{'hidden': !buttonEnable}"
    [attr.aria-hidden]="!buttonEnable"
    label="Continuar"
    (clickButton)="clickNext();"
  ></app-ion-common-button>
</ion-content>
